// Predefined sets of sizes for different kinds of products. Pick the system
// that matches the product, then choose which sizes from that system it
// actually comes in — you don't have to use all of them.
const SIZE_SYSTEMS = {
  clothing: {
    label: "Clothing (S, M, L...)",
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
  },
  volume: {
    label: "Volume (Quart, Liter, Gallon...)",
    sizes: ["Fl Oz", "Cup", "Pint", "Quart", "Liter", "Half Gallon", "Gallon"],
  },
  shoe_us: {
    label: "Shoe Size (US)",
    sizes: ["5", "6", "7", "8", "9", "10", "11", "12", "13", "14"],
  },
  ring: {
    label: "Ring Size",
    sizes: ["5", "6", "7", "8", "9", "10", "11", "12"],
  },
  weight: {
    label: "Weight (oz, lb...)",
    sizes: ["4 oz", "8 oz", "1 lb", "2 lb", "5 lb", "10 lb"],
  },
  kids_age: {
    label: "Kids Age Range",
    sizes: ["0-6mo", "6-12mo", "1-2yr", "2-4yr", "4-6yr", "6-8yr", "8-10yr", "10-12yr"],
  },
  one_size: {
    label: "One Size Only",
    sizes: ["One Size"],
  },
  custom: {
    label: "Custom (type your own)",
    sizes: [],
  },
};

export default SIZE_SYSTEMS;
